import { createApp } from 'vue';
import { createPinia } from 'pinia'

import ReviewsApp from '../../views/ReviewsApp.vue';

export default function loadReviewsApp(el) {
    createApp(ReviewsApp).use(createPinia()).mount(el);
}